import React from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./ConfirmationPop.module.scss"; 

const RejectCategoryPop = ({ show, setShow, confirmHandler }) => {
  const hideHandler = () => setShow(false);

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal`}
      onHide={hideHandler}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="px-md-5 text-center mx-auto">
          <h3 className="m-0 fw-bold text-danger">Reject Category</h3>
          <p className="mt-2 mb-0">Are you sure you want to reject this category?</p>

          <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 btn-danger"
              >
                Reject
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RejectCategoryPop;
